export default "__VITE_ASSET__BbFsYAV1__"